<template>
    <div v-if="subscription">
        <v-card>
            <v-card-text>
                <v-layout row wrap justify-center>
                    <v-flex xs12>
                        <!-- Subscription Detail -->
                        <v-card class="border-white grey darken-1">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-layout row wrap class="mb-1">
                                            <v-flex xs12>
                                                <!-- Subscription title with recurring icon -->
                                                <div>
                                                    <span class="overline grey--text text--lighten-4 font-weight-bold">
                                                        <v-icon small class="white" color="black">$vuetify.icons.rms_sync</v-icon>&nbsp;<b>{{ $t('subscription.title')}}</b>
                                                    </span>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-layout row wrap>
                                            <v-flex xs9>
                                                <div class="text-truncate">
                                                    <span class="title font-weight-regular">
                                                        <!-- Customer email -->
                                                        <router-link
                                                        :to="{name: 'user.dashboard' ,query: { tab: 'profile'}}"
                                                        exact
                                                        :style="{ cursor: 'pointer'}"
                                                        class="black--text"
                                                        >{{ subscription.metadata.email }}</router-link>
                                                        <!-- On label -->
                                                        <span class="subtitle-1 white--text">&nbsp;{{ $t('subscription.on.title') }}&nbsp;</span>
                                                        <!-- Product name -->
                                                        <v-tooltip top slot="append" color="white">
                                                            <span class="black--text text--darken-3" slot="activator">{{ company.title }}</span>
                                                            <span class="black--text body-1">{{$t('product')}}</span>
                                                        </v-tooltip>
                                                        <span class="white--text">&nbsp;•&nbsp;</span>
                                                        <!-- Plan name -->
                                                        <span class="black--text text--darken-3" v-if="subscription.plan.metadata.plan_name">{{ subscription.plan.metadata.plan_name }}</span>
                                                        <!-- Subscription trial ends status -->
                                                        <v-chip
                                                        class="ml-2"
                                                        color="blue lighten-4 blue--text font-weight-medium"
                                                        small
                                                        v-if="!(subscription.cancel_at && subscription.cancel_at_period_end) && DEFINES.SUBSCRIPTION.STATUS.TRIALING == subscription.status"
                                                        >{{ $t('subscription.trial_ends.title')}}&nbsp;{{ getRemainingTime() }}</v-chip>
                                                        <!-- Subscription active status -->
                                                        <v-chip
                                                        class="ml-2"
                                                        color="success black--text"
                                                        small
                                                        v-if="!(subscription.cancel_at && subscription.cancel_at_period_end) && DEFINES.SUBSCRIPTION.STATUS.ACTIVE == subscription.status"
                                                        ><strong>{{ subscription.status | capitalize }}</strong></v-chip>
                                                        <!-- Subscription canceld status -->
                                                        <v-chip
                                                        class="ml-2"
                                                        color="default grey--text text--darken-2 font-weight-medium"
                                                        small
                                                        v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED == subscription.status"
                                                        >{{subscription.status | capitalize }}</v-chip>
                                                        <!-- Subscription cancels in status -->
                                                        <v-tooltip top color="white" max-width="300" nudge-top="10">
                                                        <template v-slot:activator="{ on }">
                                                            <span
                                                            v-if="subscription.cancel_at && subscription.cancel_at_period_end && !subscription.ended_at"
                                                            >
                                                            <v-chip
                                                                v-on="on"
                                                                color="grey"
                                                                class="mt-0 ml-2 black--text"
                                                                small
                                                            >
                                                                <v-icon small color="black" v-on="on">$vuetify.icons.rms_clock</v-icon>
                                                                &nbsp;{{$t('subscription.cancels.title')}}&nbsp;{{ getRemainingTime()}}
                                                            </v-chip>
                                                            </span>
                                                        </template>
                                                        <div class="pa-2">
                                                            <span
                                                            class="black--text body-1"
                                                            >{{ $t('subscription.cancel.message')}}</span>
                                                        </div>
                                                        </v-tooltip>
                                                    </span>
                                                </div>
                                            </v-flex>
                                            <!-- Cancel / Reactivate according to status-->
                                            <v-flex xs3 class="text-xs-right">
                                                <!-- Cancel at period end -->
                                                <!-- Will visible only when subscription not expired and user having access to perform these actions -->
                                                <ConfirmationDialog
                                                v-if="!subscription.ended_at"
                                                :desc=" (!subscription.cancel_at_period_end) ? 'subscription.confirmation.cancel.description' : 'subscription.confirmation.reactivate.description'"
                                                :action=" (!subscription.cancel_at_period_end) ? getDialogAction('cancel', subscription, '', 'error', 'screener.btn.cancel', 'screener.btn.cancel','rms.button.do_not_cancel') : getDialogAction('resume', subscription, '', 'success', 'rms.button.reactivate', 'rms.button.reactivate',null)"
                                                :headline="(!subscription.cancel_at_period_end) ? 'subscription.confirmation.cancel.heading' : 'subscription.confirmation.reactivate.heading'"
                                                :button_type="'button'"
                                                small
                                                ></ConfirmationDialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                            <v-divider class="grey lighten-2"></v-divider>
                            <!-- Brief info -->
                            <v-card-text class="light-bg">
                                <v-layout row wrap>
                                <v-flex
                                    xs2
                                    v-if="subscription.status != DEFINES.SUBSCRIPTION.STATUS.TRIALING && DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status"
                                >
                                    <div class="grey--text text--darken-2"><b>{{ $t('subscription.next_invoice') }}&nbsp;{{$t('subscription.on.title')}}</b></div>
                                    <div class="black--text text--darken-1"><b>{{ getFormattedTimeString(subscription.current_period_end, "D MMM YYYY") }}</b></div>
                                </v-flex>
                                <v-flex xs3>
                                    <div
                                    :class="[subscription.status != DEFINES.SUBSCRIPTION.STATUS.TRIALING && DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status ? 'borderLeft pl-3' : '','pr-3 displayInline']"
                                    >
                                        <div class="grey--text text--darken-2"><b>{{ $t('subscription.started') }}</b></div>
                                        <div class="black--text text--darken-1"><b>{{ getFormattedTimeString(subscription.created, "D MMM") }}</b></div>
                                    </div>
                                    <div class="borderLeft pl-3 displayInline" v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED == subscription.status">
                                        <div class="grey--text text--darken-1"><b>{{ $t('subscription.status.ended') }}</b></div>
                                        <div>{{ getFormattedTimeString(subscription.current_period_start,"D MMM") }}</div>
                                    </div>
                                    <div class="borderLeft pl-3 displayInline" v-if="subscription.canceled_at && subscription.cancel_at_period_end">
                                        <div class="grey--text text--darken-1"><b>{{ $t('subscription.ends') }}</b></div>
                                        <div class="black--text text--darken-1"><b>{{ $t('subscription.ends_at_period_end') }}</b></div>
                                    </div>
                                </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                        <br />
                        <!-- Details -->
                        <v-card class="border-white grey darken-1">
                            <v-card-title>
                                <h3 class="white--text"><b>{{ $t('subscription.details')}}</b></h3>
                            </v-card-title>
                            <v-divider class="grey lighten-2"></v-divider>
                            <v-card-text class="light-bg">
                                <v-layout row wrap>
                                    <v-flex xs6 sm6 md4>
                                        <!-- Company Name -->
                                        <v-layout row wrap class="py-1">
                                            <v-flex xs6 class="grey--text text--darken-2"><b>{{$t('company.title')}}</b></v-flex>
                                            <v-flex xs6 class="black--text"><b>{{ company.title }}</b></v-flex>
                                        </v-layout>
                                        <!-- Current Period -->
                                        <v-layout row wrap class="py-1">
                                            <!-- Label according to subscription status -->
                                            <v-flex xs6 class="grey--text text--darken-2"><b>
                                                {{
                                                    (DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status && !subscription.cancel_at) ?
                                                    $t('subscription.current_period') :
                                                    (subscription.cancel_at && subscription.cancel_at_period_end) && !subscription.ends_at ?
                                                    $t('subscription.schedule_to_cancel.title') :
                                                    $t('subscription.ended_at.title')
                                                }}</b>
                                            </v-flex>
                                            <!-- When status is active or trialing but subscription not canceled -->
                                            <v-flex
                                                xs6
                                                v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status && !subscription.cancel_at"
                                                class="black--text"
                                            ><b>
                                                {{ getFormattedTimeString(subscription.current_period_start, "D MMM YYYY") }}
                                                <span
                                                class="grey--text text--darken-2"
                                                >&nbsp;{{$t('subscription.to')}}&nbsp;</span>
                                                {{ getFormattedTimeString(subscription.current_period_end,"D MMM YYYY")}}</b>
                                            </v-flex>
                                            <!-- When status is active or trialing but subscription ending at period end -->
                                            <v-flex
                                                xs6
                                                v-else-if="(subscription.cancel_at && subscription.cancel_at_period_end) && !subscription.ends_at"
                                                class="black--text"
                                            ><b>{{ getFormattedTimeString(subscription.current_period_end,"D MMM, HH:MM")}}</b></v-flex>
                                            <!-- When subscription has been canceled immediately -->
                                            <v-flex xs6 v-else class="black--text">{{ getFormattedTimeString(subscription.ended_at, "D MMM, HH:MM") }}</v-flex>
                                        </v-layout>
                                        <!-- Canceled At -->
                                        <v-layout
                                        row
                                        wrap
                                        class="grey--text text--darken-2 py-1"
                                        v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status && subscription.canceled_at"
                                        >
                                            <v-flex xs6 class="red--text text--darken-1"><b>{{ $t('subscription.canceled_at.title') }}</b></v-flex>
                                            <v-flex xs6 class="black--text"><b>{{ getFormattedTimeString(subscription.canceled_at, "D MMM, HH:MM") }}</b></v-flex>
                                        </v-layout>
                                        <!-- Pricing -->
                                        <v-layout v-if="subscription.plan.metadata.plan_name" row wrap class="py-1">
                                            <v-flex xs6 class="grey--text text--darken-2"><b>{{ $t('subscription.plan') }}</b></v-flex>
                                            <v-flex xs6 class="black--text"><b>{{ subscription.plan.metadata.plan_name }}</b></v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md4 offset-md2 offset-xs0>
                                        <!-- Trialing until -->
                                        <v-layout row wrap class="py-1" v-if="subscription.trial_end">
                                            <v-flex xs6 class="grey--text text--darken-2"><b>{{ $t('subscription.trialing_until.title') }}</b></v-flex>
                                            <v-flex xs6 class="white--text"><b>{{ getFormattedTimeString(subscription.trial_end, "D/MM") }}</b></v-flex>
                                        </v-layout>
                                        <!-- Discount -->
                                        <v-layout row wrap class="py-1" v-if="subscription.discount">
                                            <v-flex xs6 class="grey--text text--darken-2"><b>{{$t('subscription.discount')}}</b></v-flex>
                                            <v-flex xs6 class="white--text"><b>{{ subscription.discount.coupon.percent_off+$t('subscription.percent_off')+subscription.discount.coupon.duration }}</b></v-flex>
                                        </v-layout>
                                        <!-- Billing Method -->
                                        <v-layout row wrap class="py-1">
                                            <v-flex xs6 class="grey--text text--darken-2"><b>{{ $t('subscription.billing_method') }}</b></v-flex>
                                            <v-flex xs6>
                                                <span v-if="!subscription.ended_at" class="black--text"><b><u>{{ paymentMethod.card.brand.toUpperCase() }}</u></b></span>
                                                <span v-else class="black--text">{{ paymentMethod.card.brand.toUpperCase() }}</span>
                                                <span>&ensp;|&ensp;</span>
                                                <span class="black--text subheading">●●●●●●●●{{ paymentMethod.card.last4}}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                        <br />
                        <!-- Invoices -->
                        <v-card class="border-white grey darken-1">
                            <v-card-title>
                                <h3><b>{{ $t('subscription.invoices') }}</b></h3>
                            </v-card-title>
                            <v-divider class="grey lighten-2"></v-divider>
                            <template v-if="invoices">
                                <v-data-table :headers="headers" :items="invoices" class="invoice-pagination">
                                    <!-- Customized header -->
                                    <template v-slot:headers="props">
                                        <tr class="light-bg">
                                            <th
                                                v-for="header in props.headers"
                                                :key="header.text"
                                                :align="header.align"
                                                class="light-bg grey--text text--darken-2"
                                            ><b>{{ header.text }}</b></th>
                                        </tr>
                                    </template>
                                    <!-- Data Rows -->
                                    <template v-slot:items="props">
                                        <tr v-if="(props.item.total/100)" class="grey darken-1 black--text">
                                        <!-- Amount -->
                                        <td class="body-2 text-xs-left height-zero">
                                            <!-- Converting cents into dollar by dividing 100-->
                                            <b>{{$t('subscription.currency.'+props.item.currency)}}&nbsp;{{ (props.item.total/100).toFixed(2) }}</b>
                                        </td>
                                        <!-- Invoice status -->
                                        <td class="body-2 text-xs-left height-zero">
                                            <!-- Paid -->
                                            <v-chip
                                            v-if="DEFINES.SUBSCRIPTION.INVOICE.STATUS.PAID == props.item.status"
                                            class="ml-2"
                                            color="success black--text"
                                            small
                                            >{{$t('subscription.invoice.status.paid')}}</v-chip>
                                            <!-- Due -->
                                            <v-chip
                                            v-if="DEFINES.SUBSCRIPTION.INVOICE.STATUS.DUE == props.item.status"
                                            color="orange black--text"
                                            small
                                            >{{$t('subscription.invoice.status.due')}}</v-chip>
                                            <!-- Draft -->
                                            <v-chip
                                            v-if="DEFINES.SUBSCRIPTION.INVOICE.STATUS.DRAFT == props.item.status"
                                            color="orange black--text"
                                            small
                                            >{{$t('subscription.invoice.status.draft')}}</v-chip>
                                        </td>
                                        <!-- Invoice number -->
                                        <td class="body-2 text-xs-left height-zero"><b>{{ props.item.number }}</b></td>
                                        <!-- Customer email -->
                                        <td class="body-2 text-xs-left height-zero"><b>{{ props.item.customer_email }}</b></td>
                                        <!-- Invoice due date -->
                                        <td
                                            class="body-2 text-xs-left height-zero"
                                        ><b>{{ props.item.due_date ? moment.unix(props.item.due_date).format('D MMM') : '___' }}</b></td>
                                        <!-- Invoice created date -->
                                        <td
                                            class="body-2 text-xs-left height-zero"
                                        ><b>{{ moment.unix(props.item.created).format('D MMM, HH:MM')}}</b></td>
                                        <!-- Paid at -->
                                        <td
                                            class="body-2 text-xs-left height-zero"
                                        ><b>{{ props.item.status_transitions.paid_at ? moment.unix(props.item.status_transitions.paid_at).format('D MMM, HH:MM') : '___' }}</b></td>
                                        <!-- Invoice menu -->
                                        <td class="height-zero">
                                            <v-btn
                                            color="blue"
                                            flat
                                            small
                                            :href="props.item.invoice_pdf"
                                            target="_blank"
                                            ><u><b>{{ $t("subscription.invoice.download_pdf") }}</b></u></v-btn>
                                        </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </template>
                            <template v-else>
                                <div
                                class="text-xs-center subheading pa-5 grey--text darken-1"
                                >{{ $t('subscription.invoice.no_invoice.headline') }}</div>
                            </template>
                        </v-card>
                     </v-flex>
                </v-layout> 
            </v-card-text>
        </v-card>
    </div>
    <div v-else class="grey darken-3 text-xs-center subheading pa-5 grey--text ">
        <v-layout row wrap justify-center text-xs-center class="pa-5">
            <v-flex xs12 class="py-2 title secondary--text">{{ $t('subscription.no_subscription.headline') }}</v-flex>
            <v-flex xs12 class="py-2">
                <router-link class="primary--text subheading" :to="{ name: 'subscription.plans' }">{{ $t("subscription.browse_plans") }}</router-link>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";
import * as HELPER from "@/helpers";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
    name: "ConsumerSubscription",
    data: () => ({
        headers: [
            {text: 'AMOUNT', align: 'left', sortable: false, value: 'amount'},
            {text: 'STATUS', align: 'left', sortable: false, value: 'status'},
            {
                text: 'INVOICE NUMBER',
                align: 'left',
                sortable: false,
                value: 'invoice_number',
            },
            {text: 'CUSTOMER', align: 'left', sortable: false, value: 'customer'},
            {text: 'DUE DATE', align: 'left', sortable: false, value: 'due_date'},
            {text: 'CREATED', align: 'left', sortable: false, value: 'created'},
            {text: 'PAID AT', align: 'left', sortable: false, value: 'paid_at'},
            {text: '', align: 'left', sortable: false, value: ''},
        ]
    }),
    components: {
        ConfirmationDialog
    },
    computed: {
        ...mapState({
            subscription: state => state.subscription.subscription,
            localSubscription:state => state.subscription.localSubscription,
            paymentMethod: state => state.subscription.paymentMethod,
            invoices: state => state.subscription.invoices,
            company: state => state.company.company
        }),
        ...mapGetters({
            companyId: "company/getCurrentCompanyId"
        })
    },
    methods:{
        getFormattedTimeString: (milliseconds, dateTimeFormat) => HELPER.getFormattedTimeString(milliseconds, dateTimeFormat),
        getRemainingTime: function() {
            return HELPER.getRemainingTime(this.subscription);
        },
        getDialogAction(
            action,
            update_status,
            btn_icon,
            btn_color,
            btn_label,
            btn_yes_text,
            btn_no_text
        ) {
            return {
                button_icon: btn_icon,
                button_color: btn_color,
                method:
                action == "cancel" ? this.cancel : this.resume,
                payload: update_status,
                button_label: btn_label,
                btn_yes_text: btn_yes_text,
                btn_no_text: btn_no_text,
                btn_yes_color: btn_color,
                btn_no_color: "grey"
            };
        },
        cancel() {
            try {
                this.$store.dispatch("subscription/cancel", {
                    subscription_id: this.localSubscription.id,
                    cancelNow: false
                }).then(() => {
                    this.$store.dispatch("app/showMessage", {
                        message: i18n.t("subscription.message.canceled"),
                        color: 'success'
                    });
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: 'error'
                });
            }
        },
        resume() {
            try {
                this.$store.dispatch("subscription/resume", {
                    subscription_id: this.localSubscription.id
                })
                .then(() => {
                    this.$store.dispatch("app/showMessage", {
                        message: i18n.t("subscription.message.reactivated"),
                        color: 'success'
                    });
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: 'error'
                });
            }
        }
    }
}
</script>

<style scoped>
.light-bg {
  background: rgba(237, 242, 245, 0.6) !important;
}
.borderLeft {
  border-left: 1px solid rgba(15, 15, 15, 0.2);
}
.cursor-pointer {
  cursor: pointer;
}
.displayInline {
  display: inline-block;
}
.height-zero {
  height: 0px !important;
}
.border-white {
    border: 1px solid white;
    border-radius: 5px;
}
</style>